import Icon from '@ant-design/icons'
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon'

function MovieAnnotationSvg() {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        opacity="0.8"
        cx="28"
        cy="28"
        r="28"
        fill="#F28686"
        fillOpacity="0.8"
      />
      <path
        d="M28 45.5C18.335 45.5 10.5 37.665 10.5 28C10.5 18.335 18.335 10.5 28 10.5C37.665 10.5 45.5 18.335 45.5 28C45.5 37.665 37.665 45.5 28 45.5ZM28 48C39.0457 48 48 39.0457 48 28C48 16.9543 39.0457 8 28 8C16.9543 8 8 16.9543 8 28C8 39.0457 16.9543 48 28 48Z"
        fill="white"
      />
      <path
        d="M23.678 20.6385C24.0944 20.4243 24.5955 20.4607 24.9765 20.7328L33.7265 26.9828C34.055 27.2175 34.25 27.5963 34.25 28C34.25 28.4037 34.055 28.7825 33.7265 29.0172L24.9765 35.2672C24.5955 35.5393 24.0944 35.5757 23.678 35.3615C23.2617 35.1472 23 34.7182 23 34.25V21.75C23 21.2818 23.2617 20.8528 23.678 20.6385Z"
        fill="white"
      />
    </svg>
  )
}

export default function MovieAnnotationIcon(
  props: Partial<CustomIconComponentProps>
) {
  return <Icon component={MovieAnnotationSvg} {...props} />
}
